export default () => ({
	allTableFields: [],
	localizedFields: {},
	isBusyTable: false,
	additionalData: {},
	credit_cards: []
})